"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const View = ({
  className,
  children
}) => /*#__PURE__*/_react.default.createElement("div", {
  className: className
}, children);

var _default = (0, _styledComponents.default)(View).withConfig({
  displayName: "View",
  componentId: "sc-1csl0a0-0"
})(["display:flex;flex-direction:column;position:absolute;z-index:1;top:0;right:0;bottom:0;left:0;background:#fff;"]);

exports.default = _default;